import { render } from "./QuestionnaireRespond.vue?vue&type=template&id=3f478eea"
import script from "./QuestionnaireRespond.vue?vue&type=script&lang=ts"
export * from "./QuestionnaireRespond.vue?vue&type=script&lang=ts"
script.render = render

export default script